import { connect } from 'react-redux'
import {
  selectItem,
  selectAll,
  removeItem,
  removeAll,
  saveSelected,
  filterBy,
  filterByTags,
  filterTargetBy,
  nextStep,
  stepBack,
} from '../../../actions/campaigns/locations_selector_actions'
import { selectByTags } from '../../../actions/campaigns/common_actions'

export default connect(
  (state: any) => ({
    id: state.campaigns?.id,
    approvedLocationIDs: state.campaigns?.approvedLocationIDs,
    campaignLocationsNeedApproval: state.campaigns?.campaignLocationsNeedApproval,
    exportLocationApprovalsUrl: state.campaigns?.exportLocationApprovalsUrl,
    locations: state.campaigns?.locations || [],
    tags: state.campaigns?.tags || [],
    regions: state.campaigns?.regions || [],
    isReady: state.campaigns?.isReady,
    targetFilter: state.campaigns?.targetFilter || '',
    companyId: state.campaigns?.companyId,
    canCreateLocation: state.campaigns?.canCreateLocation || false,
    countries: state.campaigns?.countries || [],
    locationManagers: state.campaigns?.locationManagers || [],
  }),
  {
    selectItem,
    removeItem,
    selectAll,
    removeAll,
    saveSelected,
    filterBy,
    filterByTags,
    filterTargetBy,
    selectByTags,
    nextStep,
    stepBack,
  }
)
